/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Invite_Error_TitleInputs */



/**
* | output |
* | --- |
* | "Invite invalid or expired" |
*
* @param {Partner_Invite_Error_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_invite_error_title = /** @type {((inputs?: Partner_Invite_Error_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Invite_Error_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Einladung ungültig oder abgelaufen")
	return /** @type {LocalizedString} */ ("Invite invalid or expired")
});